import Home from './home'
import OrdersList from '@/pages/orders/list'
import OrdersSingle from '@/pages/orders/salesrepSingle'
import SettingsGeneral from '@/pages/settings/general'
import termsService from '@/pages/legal/termsService'
import privacyPolicy from '@/pages/legal/privacyPolicy'

import helpRoutes from '@/pages/help/routes'

let routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/orders',
    name: 'ordersList',
    component: OrdersList
  },
  {
    path: '/orders/:id',
    name: 'ordersSingle',
    component: OrdersSingle
  },
  {
    path: '/settings/',
    name: 'settingsGeneral',
    component: SettingsGeneral
  },
  {
    path: '/terms-of-service',
    name: 'termsService',
    component: termsService
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: privacyPolicy
  }
]

routes = routes.concat(helpRoutes)

export default routes



// WEBPACK FOOTER //
// ./src/apps/salesreps/routes.js